export default "__VITE_ASSET__f7ecec3e__"